<template>
    <div class="main-wrapper">
        <navbarthree></navbarthree>
        
        <div class="page-wrapper">
            <section class="banner-section banner-three">
                <div class="container">
                    <div class="row">
                        <div class="banner-info-blk">
                            <div class="row">
                                <div class="col-md-12 col-lg-5">
                                    <div class="banner-content-blk">

                                        <h1>Votre prochai<span style="color: #fff">ne</span> trouvaille, à po<span style="color: #fff">rtée</span> de clic.</h1>
                                        <h5>Trouvez votre trésor  chaque produit, une découverte.</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="banner-images">
                            <div class="ban-image">
                                <img src="../../../assets/img/bg/balloon-img.png" style="    width: 123px;" alt="">
                            </div>
                            <div class="ban-image-01">
                                <img src="../../../assets/img/bg/cloud-01.png" alt="" class="cloud-one">
                                <img src="../../../assets/img/bg/cloud-02.png" alt="" class="cloud-two">
                            </div>
                            <div class="ban-image-02">
                                <img src="../../../assets/img/main-banner-7.png" alt="">
                            </div>
                            <div class="ban-image-03">
                                <img src="../../../assets/img/fanous.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="banner-btm">
                                <div class="search-tab-col">
                                    <b-form action="listing-grid-sidebar" method="post">
                                        <div class="row align-items-center search-form">
                                            <div class="col-12 col-lg-10 datepicker-col search-group">
                                                <ul class="gap-3 d-flex">
                                                    <li>
                                                        <div class="d-flex">
                                                            <div class="flex-shrink-0">
                                                                <div class="icon-blk rounded-circle">
                                                                    <span class="material-symbols-outlined">Search</span>
                                                                </div>
                                                            </div>
                                                            <div class="flex-grow-1 ms-3">
                                                                <span class="label">Recherche</span>
                                                                <b-form-input type="text" v-model="search" name="name" class="border-0 text-truncate px-0 form-control" placeholder="Taper votre produit?" />
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-12 col-lg-2 search-group">
                                                <ul class="p-0">
                                                    <li>
                                                        <b-button @click="submitForm" variant="btn theme-btn">Search <i class="feather-search ms-1"></i></b-button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </b-form>
                                </div>
                            </div>

                            <div class="banner-btm-img-blk">
                                <img src="../../../assets/img/banner-btm-img.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="target-div" class="section-blk recommended-blk style1-blk">
                    <div class="container"  v-if="first">
                        <div class="row">
                            <div v-if="loading" class="col-sm-12">
                                <div class="d-flex justify-content-center mb-3">
                                    <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner" type="grow"></b-spinner>
                                </div>

                            </div>
                            <div class="col-sm-12" v-else>
                                <div class="row justify-content-center">
                                    <div class="col-lg-12">
                                        <div class="recommended-tabs-blk">
                                            <ul class="nav tabs-style gap-3" data-bs-tabs="tabs">
                                                <li  v-for="i in categories">
                                                    <a   aria-current="true" data-bs-toggle="tab" @click="filer(i.id)">
                                                        {{ i.name }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body tab-content">
                                    <div class="tab-pane active">
                                        <div class="recommended-carousel">
                                            <div class="row" >
                                                <div class="col-md-3 recommended-widget" v-for="item in data" :key="item._id_id">
                                                    <div class="img-blk">
                                                        <router-link to="/service-details">
                                                            <img :src="item._source.image" class="img-fluid" alt="List 1">
                                                        </router-link>
                                                        <div :class="'top-blk primary-bg-style'">
                                                            <p>{{ item._source.brand }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="content-blk">
                                                        <p><router-link to="/service-details">{{ item._source.name }}</router-link></p>
                                                        <div class="loc-blk">
                                                             <div class="detail-blk" style="    min-height: 64px;">
                                                                <div class="tags-blk">
                                                                    <a href="javscript:;"  v-if="item._source.cat3" class="tag-style">{{ item._source.cat3 }}</a>
                                                                    <a href="javscript:;" v-if="item._source.cat2" class="tag-style">{{ item._source.cat2 }}</a>
                                                                    <a href="javscript:;" v-if="item._source.cat1" class="tag-style">{{ item._source.cat1 }}</a>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div class="detail-blk">
                                                            <p><strong>Prix :</strong> <span>{{ item._source.price }}  DH</span></p>
                                                            <div class="detail-btm-blk">
                                                                <a class="rating-badge" :href="item._source.link">
                                                                   Voir détails
                                                                </a>
                                                                <small> 4,5 (20 vue)</small>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            <indexpromo />

            <indextestimonial />

            <indexprice />

            <indexsubscribe />

            <indexactivity />

            <navbarthreefooter />

        </div>
    </div>
</template>
<script>
import RecommendSlide from '../../../assets/json/recommendSlide.json'
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import axios from 'axios';

export default {
    data() {
        return {
            RecommendSlide: RecommendSlide,
            search: null,
            loading: false,
            first:false,
            data: [],
            categories: [],
            settings: {
                itemsToShow: 1,
                snapAlign: "center"
            },
            breakpoints: {
                // 700px and up
                700: {
                    itemsToShow: 2,
                    snapAlign: "center"
                },
                // 991 and up
                991: {
                    itemsToShow: 3,
                    snapAlign: "center"
                },
                // 1024 and up
                1000: {
                    itemsToShow: 4.25,
                    snapAlign: "center"
                }
            },
        }
    },
    methods: {
        submitForm() {
            this.loading=true
            this.first=true
            const element = document.getElementById('target-div');
            element.scrollIntoView({ behavior: 'smooth' });
            const apiURL = 'https://dbwes.inocod.dev/api/test/product/'+this.search; // Replace with your API URL
            axios.post(apiURL, this.formData)
                .then(response => {
                    this.data = response.data;
                    this.loading=false
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    this.loading=false
                });
        }
    },
    mounted() {
        const apiURL = 'https://dbwes.inocod.dev/api/categories'; // Replace with your API URL
        axios.post(apiURL, this.formData)
            .then(response => {
                this.categories = response.data;

            })
            .catch(error => {
                console.error('Error fetching data:', error);

            });
    },
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
}
</script>

<style>
.carousel__slide.recommended-widget {
    margin-right: 22px;
}
 .recommended-widget .img-blk img, .blog-widget .img-blk img {
    transform: translateZ(0);
    transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;
    width: 100%;
    height: 300px;
    object-fit: cover;
}
</style>